var _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _circle2, _path19, _circle3, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_my_password_re_ydq7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.36,
    height: 132.877,
    viewBox: "0 0 136.36 132.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10366",
    "data-name": "Path 10366",
    d: "M484.387,317.365h-7.256v61.857a7.39,7.39,0,0,1-7.39,7.39H414.269v.071a7.39,7.39,0,0,0,7.39,7.39h62.727a7.39,7.39,0,0,0,7.39-7.39V324.755a7.39,7.39,0,0,0-7.39-7.39Z",
    transform: "translate(-397.412 -287.579)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10367",
    "data-name": "Path 10367",
    d: "M791.34,612.72a.627.627,0,0,0,.454-1.087l-.043-.171.017-.041a1.684,1.684,0,0,1,3.106.012,14.953,14.953,0,0,1,1.314,3.743,4.982,4.982,0,0,1-.087,1.713,19.973,19.973,0,0,0,1.817-8.3,19.3,19.3,0,0,0-.12-2.151q-.1-.878-.275-1.744a20.2,20.2,0,0,0-4.007-8.564,5.377,5.377,0,0,1-2.236-2.32,4.1,4.1,0,0,1-.373-1.121,5.06,5.06,0,0,0,.328-1.746c.152-.23.423-.345.589-.569.824-1.117,1.96-.922,2.552.6,1.266.639,1.279,1.7.5,2.718-.494.648-.562,1.526-1,2.22.045.057.091.112.136.169a20.336,20.336,0,0,1,2.123,3.363,8.454,8.454,0,0,1,.5-3.927,14.158,14.158,0,0,1,2.186-3.154,1.735,1.735,0,0,1,3.091.852l0,.044q-.178.1-.348.213a.851.851,0,0,0,.343,1.548l.017,0a8.449,8.449,0,0,1-.223,1.266c1.023,3.956-1.186,5.4-4.339,5.462-.07.036-.137.071-.207.105a20.758,20.758,0,0,1,1.117,5.258,19.685,19.685,0,0,1-.014,3.179l.005-.037a5.2,5.2,0,0,1,1.776-3c1.367-1.123,3.3-1.536,4.772-2.439a.976.976,0,0,1,1.5.95l-.006.039a5.7,5.7,0,0,0-.641.309q-.178.1-.348.213a.851.851,0,0,0,.343,1.548l.017,0,.036.005a8.472,8.472,0,0,1-1.558,2.44c-.64,3.453-3.387,3.781-6.325,2.775h0a20.755,20.755,0,0,1-1.394,4.069h-4.98c-.018-.055-.034-.112-.05-.168a5.654,5.654,0,0,0,1.378-.082c-.369-.453-.739-.91-1.108-1.364a.3.3,0,0,1-.023-.027c-.187-.232-.377-.462-.564-.694h0a8.29,8.29,0,0,1,.243-2.111Z",
    transform: "translate(-669.971 -484.633)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10368",
    "data-name": "Path 10368",
    d: "M593.013,277.681a2.279,2.279,0,0,0,3.445.422l10.353,4.671,2-2.546L596.47,274.77a2.276,2.276,0,0,0-3.457,2.911Z",
    transform: "translate(-526.492 -256.309)",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10369",
    "data-name": "Path 10369",
    d: "M653.375,286.133l1.027,5.819a1.977,1.977,0,0,1-1.792,2.315l-17.448,1.372-20.509-9.179,2.45-4.65,17.8,5.638Z",
    transform: "translate(-542.423 -261.849)",
    fill: "#f6f8fb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18148",
    "data-name": "Rectangle 18148",
    width: 77.508,
    height: 76.709,
    rx: 26.744,
    transform: "translate(0 20.114)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10370",
    "data-name": "Path 10370",
    d: "M364.64,287.865a5.871,5.871,0,0,0-5.871,5.871v61.928a5.871,5.871,0,0,0,5.871,5.871h40.034a28.563,28.563,0,0,0,28.563-28.564V293.735a5.871,5.871,0,0,0-5.871-5.871Z",
    transform: "translate(-357.25 -266.231)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10371",
    "data-name": "Path 10371",
    d: "M461.576,349.5H426.369a1.218,1.218,0,1,1,0-2.436h35.207a1.218,1.218,0,0,1,0,2.436Z",
    transform: "translate(-405.287 -309.068)",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10372",
    "data-name": "Path 10372",
    d: "M461.576,443.5H426.369a1.218,1.218,0,1,1,0-2.436h35.207a1.218,1.218,0,0,1,0,2.436Z",
    transform: "translate(-405.287 -377.092)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10373",
    "data-name": "Path 10373",
    d: "M438.433,396.527h-63.8a1.218,1.218,0,0,1,0-2.436h63.8a1.218,1.218,0,1,1,0,2.436Z",
    transform: "translate(-367.847 -343.102)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10374",
    "data-name": "Path 10374",
    d: "M376.887,175.621l-6.356,13.541,24.45-2.476-5.1-13Z",
    transform: "translate(-268.139 -125.69)",
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10375",
    "data-name": "Path 10375",
    d: "M405.343,438.307l-2.318-.02L402,429.138l3.421.029Z",
    transform: "translate(-290.911 -310.55)",
    fill: "#a0616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M740.5,672.092a1.038,1.038,0,0,0,1.028,1.045l4.609.038.807-1.635.3,1.644,1.739.016-.439-5.863-.605-.04-2.468-.17-.8-.053-.014,1.659-3.7,2.511A1.036,1.036,0,0,0,740.5,672.092Z",
    transform: "translate(-633.493 -540.649)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M315.478,436.832l-2.21-.7,1.707-9.047,3.262,1.033Z",
    transform: "translate(-226.7 -309.065)",
    fill: "#a0616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10378",
    "data-name": "Path 10378",
    d: "M644.805,667.436a1.038,1.038,0,0,0,.675,1.3l4.394,1.391,1.252-1.326-.2,1.658,1.658.526,1.3-5.733-.567-.216-2.309-.888-.745-.285-.5,1.581-4.277,1.313A1.036,1.036,0,0,0,644.805,667.436Z",
    transform: "translate(-564.208 -538.327)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10379",
    "data-name": "Path 10379",
    d: "M701.546,416.522,679.316,420.6s-3.566,2.667-2.612,3.622,1.1.807.475,1.434-1.982,1.464-1.995,2.013-9.962,25.143-9.962,25.143,1.105-.553.276.276a2.4,2.4,0,0,0-.829,1.514l-3.869,26.12,6.283.37,6.152-23.813,13.723-22.246s1.362,19.838,1.419,21.158.886-.339.057,1.319-1.382.553-.829,1.658-1.991,23.609-1.991,23.609h5.735l12.3-46.644S708.026,422.793,701.546,416.522Z",
    transform: "translate(-575.818 -359.335)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10380",
    "data-name": "Path 10380",
    d: "M738.84,279.087l-8.9-.925-2.307,3-2.688,1.431a6.708,6.708,0,0,0-3.541,6.345l3.141,18.271s-2.653,5.974-.829,7.461-1.41,5.169,2.487,3.316,20.725.276,20.725.276l-3.592-10.225,2.684-10.047.3-8.424a7.137,7.137,0,0,0-5.068-7.082l-.375-.113Z",
    transform: "translate(-619.661 -259.209)",
    fill: "#f6f8fb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10381",
    "data-name": "Path 10381",
    d: "M801.869,227.555a12.887,12.887,0,0,1-2.227,7.075,13.424,13.424,0,0,0-1.871-3.462,10.776,10.776,0,0,1-1.147,6.824,1.451,1.451,0,0,1-.123.079,4.23,4.23,0,0,1-3.679.451,8.251,8.251,0,0,0,.709-10,12.574,12.574,0,0,1-1.7-2.546c-.57-1.529-.022-3.213.323-4.808.323-1.484.38-3.25-.616-4.338a1.046,1.046,0,0,1,.959-.441,1.979,1.979,0,0,1,1.345,1.17,8.538,8.538,0,0,0,.869,1.633c.735.888,1.985,1.1,3.039,1.567A7.6,7.6,0,0,1,801.869,227.555Z",
    transform: "translate(-670.43 -214.504)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10382",
    "data-name": "Path 10382",
    d: "M590.92,688.373a.328.328,0,0,0,.329.329h69.994a.329.329,0,0,0,0-.658H591.249a.328.328,0,0,0-.329.329Z",
    transform: "translate(-525.248 -555.825)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 2.487,
    cy: 2.487,
    r: 2.487,
    transform: "translate(129.503 66.252)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10383",
    "data-name": "Path 10383",
    d: "M745.833,228.292c.146-.511-.86,2.61-.374,2.667a30.756,30.756,0,0,1,6.782,2.189c.069-.008.139-.016.206-.026.165-.018.326-.044.485-.074,3.584-.678,4.962-6.183,4.962-6.233,0-.247-.594-7.045-1.53-7.145a6.9,6.9,0,0,0-.74-.04H753.3a10.793,10.793,0,0,0-1.458-.211h0c-4.674-.356-8.36,2.493-8.016,5.96l.008.012c.1.149.188.29.265.425s.139.247.194.362c.426.885-.669,2,.057,2.207.966.277-2.54,9.366,1.283,9.366C743.772,238.277,745.431,229.7,745.833,228.292Z",
    transform: "translate(-635.882 -216.676)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 5.497,
    cy: 5.497,
    r: 5.497,
    transform: "translate(108.627 5.955)",
    fill: "#a0616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10384",
    "data-name": "Path 10384",
    d: "M743.89,225.4c.092.048.181.093.273.137s.192.093.287.135c1.841.835,3.339.928,4.248-.272a5.081,5.081,0,0,1,.418-1.831,2.942,2.942,0,0,0,.485,1.831h1.831c1.886,1.252,2.854,1.382,1.545,5.491-.365,1.145-1.816,7.807-1.245,8.795.165-.018,1.922-7.315,2.081-7.345,3.584-.678,5.861-6.582,5.569-6.916a6.156,6.156,0,0,0-.638-2.738,6.3,6.3,0,0,0-2.393-2.6,11.1,11.1,0,0,0-1.912-.718l-.047-.012c-.2-.054-.408-.1-.614-.147a11.284,11.284,0,0,0-1.288-.2c-.031,0-.061,0-.09,0a.971.971,0,0,0-.491.135s0,0,0,0a.926.926,0,0,0-.273.243.935.935,0,0,0-.2.581h-2.038q-.113,0-.226.006a5.466,5.466,0,0,0-5.27,5.139C743.892,225.211,743.89,225.305,743.89,225.4Z",
    transform: "translate(-635.946 -216.401)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 3.622,
    cy: 3.622,
    r: 3.622,
    transform: "translate(116.342 0)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10385",
    "data-name": "Path 10385",
    d: "M820.021,421.575a2.279,2.279,0,0,0-1.027-3.315l.018-11.358-3.14-.777.077,13.49a2.275,2.275,0,0,0,4.072,1.96Z",
    transform: "translate(-688.003 -351.81)",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10386",
    "data-name": "Path 10386",
    d: "M774.733,301.46l4.887-3.321a1.977,1.977,0,0,1,2.846.686l8.4,15.353.032,22.469-5.245-.329-2.153-18.55Z",
    transform: "translate(-658.266 -273.418)",
    fill: "#f6f8fb"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10387",
    "data-name": "Path 10387",
    d: "M490.926,495.453H438.7a4.283,4.283,0,0,0,0,8.567h52.228a4.283,4.283,0,0,0,0-8.567Z",
    transform: "translate(-411.991 -416.454)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M490.2,503.572H437.975a4.56,4.56,0,0,1,0-9.119H490.2a4.56,4.56,0,0,1,0,9.119Zm-52.228-8.567a4.007,4.007,0,0,0,0,8.014H490.2a4.007,4.007,0,1,0,0-8.014Z",
    transform: "translate(-411.268 -415.73)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M586.512,556.716H563.463a1.218,1.218,0,1,1,0-2.436h23.048a1.218,1.218,0,1,1,0,2.436Z",
    transform: "translate(-504.497 -459.025)",
    fill: "#6c63ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.84e1f5986cb067ef627d2286efc6c2a6.svg";
export { ForwardRef as ReactComponent };